"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var World_exports = {};
__export(World_exports, {
  default: () => World_default
});
module.exports = __toCommonJS(World_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 2.75C9.47135 2.75 8.5013 2.94531 7.58984 3.33594C6.67839 3.72656 5.8776 4.26693 5.1875 4.95703C4.51042 5.63411 3.97656 6.42839 3.58594 7.33984C3.19531 8.2513 3 9.22135 3 10.25C3 11.2786 3.19531 12.2487 3.58594 13.1602C3.97656 14.0716 4.51042 14.8724 5.1875 15.5625C5.8776 16.2396 6.67839 16.7734 7.58984 17.1641C8.5013 17.5547 9.47135 17.75 10.5 17.75C11.5286 17.75 12.4987 17.5547 13.4102 17.1641C14.3216 16.7734 15.1159 16.2396 15.793 15.5625C16.4831 14.8724 17.0234 14.0716 17.4141 13.1602C17.8047 12.2487 18 11.2786 18 10.25C18 9.22135 17.8047 8.2513 17.4141 7.33984C17.0234 6.42839 16.4831 5.63411 15.793 4.95703C15.1159 4.26693 14.3216 3.72656 13.4102 3.33594C12.4987 2.94531 11.5286 2.75 10.5 2.75ZM9.75781 16.207C9.01562 16.1029 8.32552 15.8815 7.6875 15.543C7.04948 15.2044 6.48958 14.7682 6.00781 14.2344C5.53906 13.7005 5.16797 13.0951 4.89453 12.418C4.63411 11.7409 4.50391 11.0182 4.50391 10.25C4.50391 10.0156 4.51693 9.78776 4.54297 9.56641C4.56901 9.34505 4.60807 9.1237 4.66016 8.90234L8.25391 12.4961V13.2578C8.25391 13.6615 8.39714 14.013 8.68359 14.3125C8.98307 14.599 9.34115 14.7422 9.75781 14.7422V16.207ZM14.9336 14.293C14.8294 13.9935 14.6471 13.7461 14.3867 13.5508C14.1393 13.3555 13.8464 13.2578 13.5078 13.2578H12.7461V10.9922C12.7461 10.7969 12.6745 10.6276 12.5312 10.4844C12.388 10.3281 12.2122 10.25 12.0039 10.25H7.49219V8.74609H8.99609C9.20443 8.74609 9.38021 8.67448 9.52344 8.53125C9.67969 8.38802 9.75781 8.21224 9.75781 8.00391V6.5H11.2422C11.6589 6.5 12.0104 6.35677 12.2969 6.07031C12.5964 5.77083 12.7461 5.41276 12.7461 4.99609V4.68359C13.293 4.91797 13.8008 5.21745 14.2695 5.58203C14.7253 5.95964 15.1159 6.38932 15.4414 6.87109C15.7799 7.35286 16.0404 7.88021 16.2227 8.45312C16.4049 9.02604 16.4961 9.625 16.4961 10.25C16.4961 11.0312 16.3529 11.7669 16.0664 12.457C15.793 13.1471 15.4154 13.7591 14.9336 14.293Z",
      fill: "currentColor"
    }
  )
);
const SvgWorld = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var World_default = SvgWorld;
